import React from 'react';

import { Logger } from '@kinopoisk-int/logger';

export type ControlErrorBoundaryProps = {
    onError?: (error: Error, info: React.ErrorInfo) => void;
    fallback?: React.ComponentType;
    logger: Logger;
};

export class ControlErrorBoundary extends React.Component<
    React.PropsWithChildren<ControlErrorBoundaryProps>,
    { error: Error | null }
> {
    constructor(props: ControlErrorBoundaryProps) {
        super(props);

        this.state = { error: null };
    }

    static getDerivedStateFromError(error: Error) {
        return { error };
    }

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        const { onError, logger } = this.props;

        logger.error(
            {
                error,
                errorType: 'error-boundary',
                block: 'PlayerSkin',
            },
            error.message
        );

        if (onError) {
            onError(error, info);
        }
    }

    render() {
        const { error } = this.state;
        // eslint-disable-next-line react/prop-types
        const { fallback: Fallback, children } = this.props;

        if (error !== null) {
            return Fallback ? <Fallback /> : null;
        }

        return children;
    }
}
